<template>
    <div class="card my-1">
        <div class="card-header text-white text-center app-class-summary-panel-headings">
            <h4>
                <strong>No of Clinical HRH : </strong>
                <ComponentColorCoderBool style="color:white !important;"
                v-bind:prop_qst_model="data_qst_1" 
                v-bind:prop_qst_show_bools_as_sym="false"/>
            </h4>
        </div>
        <div class="card-body app-class-summary-panel-body">
            <v-simple-table>
                <template v-slot:default>
                    <tbody>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                No of Clinical HRH absent
                            </td>
                            <td class="app-class-text-light text-right">
                                {{data_staff_roster_infered.no_of_hrh_clinical_absent}}
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                No of Nurses/Midwives
                            </td>
                            <td class="app-class-text-light text-right">
                                <span>
                                    {{data_staff_roster_infered.no_of_hrh_nurses}}/
                                    {{data_staff_roster_infered.no_of_hrh_midwives}}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                No of Nurses/Midwives Absent
                            </td>
                            <td class="app-class-text-light text-right">
                                <span>
                                    {{data_staff_roster_infered.no_of_hrh_nurses_absent}}/
                                    {{data_staff_roster_infered.no_of_hrh_midwives_absent}}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                No of Chews
                            </td>
                            <td class="app-class-text-light text-right">
                                {{data_staff_roster_infered.no_of_hrh_chews}}
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                No of Chews Absent
                            </td>
                            <td class="app-class-text-light text-right">
                                {{data_staff_roster_infered.no_of_hrh_chews_absent}}
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                No of JChews
                            </td>
                            <td class="app-class-text-light text-right">
                                {{data_staff_roster_infered.no_of_hrh_jchews}}
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                No of Non Clinical HRH
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_2" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                No of Non Clinical HRH Absent
                            </td>
                            <td class="app-class-text-light text-right">
                                {{data_staff_roster_infered.no_of_hrh_non_clinical_absent}}
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                No of Male HRH
                            </td>
                            <td class="app-class-text-light text-right">
                                {{data_staff_roster_infered.no_of_hrh_male}}
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                No of Female HRH
                            </td>
                            <td class="app-class-text-light text-right">
                                {{data_staff_roster_infered.no_of_hrh_female}}
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </div>
    </div>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

//GENERIC COMPONENTS
import ComponentColorCoderBool from '@/components/ComponentColorCoderBool';

//########################################
//IMPORTS components
//########################################

//########################################
//CONSTS and VARS
//########################################

var glo_field_staff_roster=[]

//########################################
//MAIN
//########################################
export default {
    name: 'ComponentSummary15',

    props:[
        'prop_submission'
    ],

    components:{
        //GENERIC COMPONENTS
        ComponentColorCoderBool
    },

    data: function()
    {
        return {
        }
    },

    computed:{
        data_qst_1:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["surv_start/HumResMan01/serv51"];
        },
        data_qst_2:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["surv_start/HumResMan01/serv52"];
        },
        /**
         * extrapolate the staff-roster list into a global var
         * and infer required fields
        */
        data_staff_roster_infered:function()
        {
            glo_field_staff_roster=this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_special_case_staff_roster;
            return ENGINE_qst_phc_bhcpf.helper_infer_data_fields_from_staff_roster(glo_field_staff_roster)
        }
    }
}

//call all with signature func_imp.call(this,param_1,param_2)
//########################################################################################
//HELPERS
//########################################################################################

//########################################################################################
//API_REQUESTS
//########################################################################################

//########################################################################################
//DATA_OPPS
//########################################################################################

//########################################################################################
//ACTIONS
//########################################################################################
</script>
